import React from 'react'
import '../PagesCSS/LessonsPage.css'
import LessonsBox from '../ReusableComponents/LessonsBox';

const LessonsPage = () => {

    return (
        <div className='App-lessons-body'>
            <LessonsBox/>
        </div>
      )
}

export default LessonsPage